var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsterisk18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 7.973V3a1 1 0 0 1 2 0v4.972l4.687-1.523a1 1 0 0 1 .618 1.902l-4.618 1.5 3.097 4.592a1 1 0 0 1-1.659 1.119l-3.129-4.64-3.129 4.64a1 1 0 0 1-1.658-1.119l3.098-4.592-4.616-1.5A1 1 0 0 1 3.31 6.45L8 7.973z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggNy45NzNWM2ExIDEgMCAwIDEgMiAwdjQuOTcybDQuNjg3LTEuNTIzYTEgMSAwIDAgMSAuNjE4IDEuOTAybC00LjYxOCAxLjUgMy4wOTcgNC41OTJhMSAxIDAgMCAxLTEuNjU5IDEuMTE5bC0zLjEyOS00LjY0LTMuMTI5IDQuNjRhMSAxIDAgMCAxLTEuNjU4LTEuMTE5bDMuMDk4LTQuNTkyLTQuNjE2LTEuNUExIDEgMCAwIDEgMy4zMSA2LjQ1TDggNy45NzN6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export { SvgAsterisk18 as ReactComponent };